import axios from "axios";
import { scrapMarketAdmin } from "../config/configURL";
import { toast } from "react-toastify";


export const getAllEvents = (startDate, endDate) => (dispatch) => {
    dispatch({ type: "GETING_ALL_EVENTS" })
    scrapMarketAdmin.get(`/events/read/add-events?startDate=${startDate}&&endDate=${endDate}`).then((res) => {
        dispatch({ type: "GOT_ALL_EVENTS", payload: res.data })

    }).catch((error) => {
        dispatch({ type: "CANNOT_GET_ALL_EVENTS" })

    })
}


export const getSingleEvent = (eventType, startDate, endDate) => (dispatch) => {
    dispatch({ type: "GETING_SINGLE_EVENT" })
    scrapMarketAdmin.get(`/events/read/read-single-event/${eventType}?startDate=${startDate}&&endDate=${endDate}`).then((res) => {
        dispatch({ type: "GOT_SINGLE_EVENTS", payload: res.data })
    }).catch((error) => {
        dispatch({ type: "CANNOT_GET_SINGLE_EVENTS" })

    })
}

export const getSingleEventWithFilter = (eventType, startDate, endDate, city, state, phoneNumber) => (dispatch) => {
    dispatch({ type: "GETING_SINGLE_EVENT" })
    scrapMarketAdmin.get(`/events/read/filter-single-event/${eventType}?city=${city}&&phoneNumber${phoneNumber}&&state=${state}&&startDate=${startDate}&&endDate=${endDate}`).then((res) => {
        dispatch({ type: "GOT_SINGLE_EVENTS", payload: res.data })
        console.log(res.data)
    }).catch((error) => {
        dispatch({ type: "CANNOT_GET_SINGLE_EVENTS" })

    })
}